import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import SeasonPage from './pages/SeasonPage';
import EpisodePage from './pages/EpisodePage';
import ImportPage from './pages/ImportPage';
import LibraryPage from './pages/LibraryPage';
import CreateEpisodePage from './pages/CreateEpisodePage';
import NotFoundPage from './pages/NotFoundPage';
import InvitePage from './pages/InvitePage';
import SharingPage from './pages/SharingPage';
import { SignInPage, useAuth } from './auth';

/**
 * The story player is rendered OUTSIDE <Layout> on purpose: it is a fullscreen
 * experience with its own chrome and must not inherit the nav bar.
 */
export default function App() {
  const { user } = useAuth();

  // Checking the session: a quiet dark frame, no flash of the sign-in form.
  if (user === undefined) return <div className="min-h-full bg-ink-950" aria-busy="true" />;

  if (!user) {
    return (
      <Routes>
        {/* Invite links work signed out: they show what is shared, then sign-in. */}
        <Route path="/invite/:token" element={<InvitePage />} />
        <Route path="*" element={<SignInPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/invite/:token" element={<InvitePage />} />
      {/* The story player is a distinct mode, not just a route variant, so the
          `fullscreen` flag must be passed explicitly here. */}
      <Route
        path="/play/:episodeId"
        element={<EpisodePage fullscreen />}
      />
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/season/:year" element={<SeasonPage />} />
        <Route path="/episode/:episodeId" element={<EpisodePage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/create" element={<CreateEpisodePage />} />
        <Route path="/create/:episodeId" element={<CreateEpisodePage />} />
        {/* Old links and bookmarks keep working. */}
        <Route path="/upload" element={<Navigate to="/import" replace />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/sharing" element={<SharingPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}